import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

// import {DomainSharedError} from '../../shared/Errors/DomainSharedError.js'
import {HttpSearchRepository} from '../Repositories/HttpSearchRepository.js'
import {GetAggregationsRequestSearch} from '../Request/GetAggregationsRequestSearch.js'

class GetAggregationsSearchUseCase extends UseCase {
  #config
  #repository

  static create({config}) {
    return new GetAggregationsSearchUseCase({
      config,
      repository: HttpSearchRepository.create({config})
    })
  }

  constructor({config, repository}) {
    super()
    this.#config = config
    this.#repository = repository
  }

  @tracer({metric: 'GetAggregationsSearchUseCase#execute'})
  @AsyncInlineError()
  async execute({listingSectionId, search}) {
    const [error, response] = await this.#repository.getAggregationsFromSearch({
      config: this.#config,
      searchRequest: GetAggregationsRequestSearch.createFromSearch({config: this.#config, listingSectionId, search})
    })

    if (error) return Promise.reject(error)

    return response
  }
}

export const factory = GetAggregationsSearchUseCase.create
